/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetMcpLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMcpLimitsRequest = createAction<PayloadData<void>>('GET_MCP_LIMITS__GET_MCP_LIMITS__REQUEST');
export const getMcpLimitsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_MCP_LIMITS__GET_MCP_LIMITS__SUCCESS');
export const getMcpLimitsFailure = createAction<PayloadData<Error, void, true>>('GET_MCP_LIMITS__GET_MCP_LIMITS__FAILURE');

export const getMcpLimitsActions = [
    getMcpLimitsRequest,
    getMcpLimitsSuccess,
    getMcpLimitsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMcpLimits = (config?: GetMcpLimits$Config) => {
    return {
        CALL_API: {
            types: getMcpLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/mcp-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

